// 手机子页面：记录表按字段展示，比较表保留横向关系；扩大原生按钮触控区域，电脑布局及业务事件不变。
import { ResponsiveTable } from "../components/mobile/ResponsiveTable";
import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { ScrollText, UserCog, ArrowRight } from "lucide-react";
import { fmtDT } from "../lib/date";

export default function AuditLog() {
  const { lang, api } = useApp();
  const zh = lang === "zh";
  const [logs, setLogs] = useState([]);
  const [sp, setSp] = useSearchParams();
  const scope = sp.get("scope") || "";
  const setScope = (k) => setSp(k ? { scope: k } : {});
  const load = useCallback(async () => { try { const { data } = await api.get("/audit-logs", { params: scope ? { scope } : {} }); setLogs(data || []); } catch { setLogs([]); } }, [api, scope]);
  useEffect(() => { load(); }, [load]);
  const tab = (k) => `px-3 py-1.5 rounded-lg text-sm font-medium ${scope === k ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`;

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><ScrollText className="h-6 w-6 text-slate-600" />{zh ? "审计日志 Audit Log" : "Audit Log"}</h1>
        <p className="text-slate-500 text-sm">{zh ? "所有审批、状态变化与 Override 的不可篡改记录" : "Immutable record of approvals, status changes & overrides"}</p>
      </div>
      <div className="flex flex-wrap items-center gap-2" data-testid="audit-tabs">
        <button className={"max-md:min-h-11 max-md:min-w-11 " + (tab(""))} onClick={() => setScope("")} data-testid="audit-tab-all">{zh ? "全部" : "All"}</button>
        <button className={"max-md:min-h-11 max-md:min-w-11 " + (tab("impersonation"))} onClick={() => setScope("impersonation")} data-testid="audit-tab-impersonation"><UserCog className="h-3.5 w-3.5 inline mr-1 -mt-0.5" />{zh ? "代操作记录" : "Impersonation"}</button>
        {scope === "impersonation" && <span className="text-xs text-slate-400" data-testid="audit-impersonation-hint">{zh ? "谁切换进了哪个分包商账号、何时、改了什么（含短信提醒分包商）" : "Who entered which subcontractor account, when, and what changed"}</span>}
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-testid="audit-table">
        <div className="overflow-x-auto">
          <ResponsiveTable className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500">
              <tr>
                <th className="text-left font-medium px-4 py-3">{zh ? "时间" : "Time"}</th>
                <th className="text-left font-medium px-3 py-3">{zh ? "操作人" : "Actor"}</th>
                <th className="text-left font-medium px-3 py-3">{zh ? "动作" : "Action"}</th>
                <th className="text-left font-medium px-3 py-3">{zh ? "对象" : "Entity"}</th>
                <th className="text-left font-medium px-4 py-3">{zh ? "详情" : "Detail"}</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 && <tr><td colSpan={5} className="text-center text-slate-300 py-10">—</td></tr>}
              {logs.map((l) => (
                <tr key={l.id} className={`border-t border-slate-100 ${l.impersonatedBy || l.action === "auth.impersonate" ? "bg-amber-50/40" : ""}`} data-testid={`audit-row-${l.id}`}>
                  <td className="px-4 py-2.5 text-slate-500 whitespace-nowrap font-mono text-xs">{fmtDT(l.at)}</td>
                  <td className="px-3 py-2.5 text-slate-700 whitespace-nowrap">
                    {l.impersonatedBy
                      ? <span className="inline-flex items-center gap-1" title={zh ? "代操作：操作者 → 分包商账号" : "Impersonation: operator → subcontractor"}><UserCog className="h-3.5 w-3.5 text-amber-600" /><b>{l.impersonatedByName || l.impersonatedBy}</b><ArrowRight className="h-3 w-3 text-slate-400" />{l.actorName || l.actor}</span>
                      : <>{l.actorName || l.actor} <span className="text-[10px] text-slate-400">{l.role}</span></>}
                  </td>
                  <td className="px-3 py-2.5"><span className={`font-mono text-xs ${l.action === "auth.impersonate" ? "text-amber-700 font-semibold" : "text-indigo-600"}`}>{l.action}</span></td>
                  <td className="px-3 py-2.5 text-slate-400 font-mono text-xs">{l.entityType}{l.action === "auth.impersonate" ? ` · ${l.entityId}` : ""}</td>
                  <td className="px-4 py-2.5 text-slate-600">{l.detail}</td>
                </tr>
              ))}
            </tbody>
          </ResponsiveTable>
        </div>
      </div>
    </div>
  );
}
